import authLayout from './layouts/auth.vue'
import defaultLayout from './layouts/default.vue'
import errorLayout from './layouts/error.vue'

export default { authLayout, defaultLayout, errorLayout }